import httpClient from "./httpClient";

const InventoryService = {
  async findAll(params = {}) {
    return await httpClient.get("/inventory", { params });
  },

  async findById(id) {
    return await httpClient.get(`/inventory/${id}`);
  },

  async alerts() {
    return await httpClient.get("/inventory/alerts");
  },

  async create(entity) {
    return await httpClient.post("/inventory", entity);
  },

  async update(id, entity) {
    return await httpClient.put(`/inventory/${id}`, entity);
  },

  async delete(id) {
    return await httpClient.delete(`/inventory/${id}`);
  }
};

export default InventoryService;
